import { useState } from "react"
import FormValidators from '../helpers/FormValidators'
import FormValidationMessages from '../constants/FormValidationMessages'

const useFormState = (initiaState) => {

  const [formData, setFormData] = useState(initiaState || {})
  const [formErrors, setFormErrors] = useState({})
  const [formIsDirty, setFormIsDirty] = useState(false)

  const onFormDataChanged = (key, value) => {
    setFormData(data => ({
      ...data,
      [key]: value
    }))
    setFormIsDirty(true)
  }

  const onFormErrorsChanged = (key, error) => {
    setFormErrors(errors => ({
      ...errors,
      [key]: error
    }))
  }

  // This method validates a single form field based on validationConfig. Returns TRUE if valid
  const validateFormField = (key, value, validationConfig) => {
    const fieldValue = value
    const field = validationConfig?.find(field => field.key === key)

    if (!field) return true
    onFormErrorsChanged(field.key, null)

    // isRequired validation
    if (field.rules?.isRequired && FormValidators.isNullOrEmpty(fieldValue)) {
      const error = { message: FormValidationMessages.REQUIRED }
      onFormErrorsChanged(field.key, error)
      return false
    }

    // isUrl validation
    if (field.rules?.isUrl && FormValidators.isInvalidUrl(fieldValue)) {
      const error = { message: FormValidationMessages.INVALID_URL }
      onFormErrorsChanged(field.key, error)
      return false
    }

    // isEmail validation
    if (field.rules?.isEmail && !FormValidators.emailValidator(fieldValue)) {
      const error = { message: FormValidationMessages.INVALID_EMAIL }
      onFormErrorsChanged(field.key, error)
      return false
    }

    // regex validation
    if (field.rules?.regex && !FormValidators.regexValidator(fieldValue, field.rules?.regex?.ex)) {
      const error = { message: field.rules?.regex?.message }
      onFormErrorsChanged(field.key, error)
      return false
    }

    // custom validation
    if (typeof field.rules?.customValidation?.func === "function") {
      const [customValidationIsValid, customValidationMessage] = field.rules?.customValidation?.func(fieldValue, formData)

      if (!customValidationIsValid) {
        const error = { message: customValidationMessage }
        onFormErrorsChanged(field.key, error)
        return false
      }
    }
  
    return true
  }

  // This method validates the full form based on validationConfig. Returns TRUE if valid
  const validateForm = (validationConfig) => {
    let formIsValid = true

    if (!formData) return formIsValid //  If formData is null, this method returns TRUE (Avoids null pointer)

    validationConfig?.forEach(field => {
      const fieldIsValid = validateFormField(
        field.key, 
        formData[field.key],
        validationConfig
      )
      if (formIsValid && !fieldIsValid) {
        formIsValid = false
      }
    })
    return formIsValid
  }

  return {
    formData, 
    formErrors, 
    formIsDirty,
    setFormData, 
    setFormErrors,
    onFormDataChanged, 
    validateFormField,
    validateForm,
    setFormIsDirty
  }
}


export default useFormState